import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';

import { PATHS } from 'src-ironside/app-routing.module';
import { Supplier } from 'src-ironside/repositories/supplier.repository';
import { AccueilDataService } from 'src-ironside/services/accueil-data.service';
import { CommonService } from 'src-ironside/services/common.service';
import { ScreenMediator } from 'src-ironside/services/screen.mediator';
import { SessionStorageService } from 'src-ironside/services/session-storage.service';
import { BreadCrumbItem } from 'src-ironside/shared/components/bread-crumb/bread-crumb.component';
import { UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { Contact } from 'src-ironside/contact-page/contact-page.component';
import { TranslateDynamicLanguagePipe } from 'src-ironside/pipes/translateDynamicLanguage.pipe';
import { ParametreNomtableService } from 'src/app/shared/services/parametre-nomtable.service';
import { PermissionService } from 'src-ironside/services/permission.service';
import { ExportResourceType } from 'src-ironside/enums/resource.enum';

@Component({
    selector: 'app-fournisseur-detail',
    templateUrl: './fournisseur-detail.component.html',
    styleUrls: ['././fournisseur-detail.component.scss'],
})
export class FournisseurDetailComponent {
    detailSupplier!: any;
    contactData: any[] = [];
    listIdContact: any[] = [];
    idSupplier!: any;
    listNews: any[] = [];
    listTrainingNews: any[] = []; // Formations
    listMarketingNews: any[] = [];
    listPromotionNews: any[] = [];
    listFileSupplier: any[] = [];
    itemPdfShow: any;
    visibleItem: boolean = false;
    pdfLoaded: boolean = false;

    logo = 'src-ironside/assets/images/image-default.jpg';
    roleUser = localStorage.getItem('role');

    exportResourcePermissionMap: { [key: string]: ExportResourceType } = {
        'export-services-apres-vente': ExportResourceType.PI_SAV,
        'export-oeuvres-art': ExportResourceType.TI_ARTW,
        'export-informations-commerciales': ExportResourceType.PI_COM,
        'export-fiches-techniques': ExportResourceType.DATA_SHEET,
        'export-certificat-environnement': ExportResourceType.ENVIRONMENTAL,
        'export-vues-eclatees': ExportResourceType.TI_VIEW,
        'export-certificat-ironside': ExportResourceType.TI_CER_IR,
        'export-certificat-usine': ExportResourceType.TI_CER,
        'export-instruction-manual': ExportResourceType.PI_MAN,
        'export-autres-infos-produits': ExportResourceType.PI_INF,
        'export-autres-infos-techniques': ExportResourceType.TI_INF,
        'export-engagement-reach': ExportResourceType.REACH,
        'export-certificats-sociaux': ExportResourceType.SOCIAL,
        'export-ressource-pieces-detachees': ExportResourceType.TI_PART,
        'export-ressource-videos': ExportResourceType.VIDEO,
        'export-photos-hd': ExportResourceType.PHOTO,
        'export-photos-bd': ExportResourceType.PHOTO_THUMBNAIL,
        'export-rapport-essais': ExportResourceType.TI_REP,
    };

    constructor(
        private dynamicDocumentService: DynamicDocumentService,
        private _activeRouter: ActivatedRoute,
        public userService: UserService,
        private translate: TranslateService,
        private accueilDataService: AccueilDataService,
        private screenMediator: ScreenMediator,
        private sessionStorageService: SessionStorageService,
        private translateDynamicLanguage: TranslateDynamicLanguagePipe,
        private parametreNomtableService: ParametreNomtableService,
        public permissionService: PermissionService
    ) {}

    ngOnInit() {
        debugger;
        this.getParamUrl();
        this.getDetailSupplier();
    }

    get breadCrumb() {
        let breadCrumbs: BreadCrumbItem[] = [
            { name: this.translate.instant('Menu.home'), url: PATHS.home_en },
            { name: this.translate.instant('Menu.suppliers'), url: PATHS.suppliers_en },
            { name: this.detailSupplier?.companyName },
        ];
        return breadCrumbs;
    }
    getParamUrl(): void {
        this.idSupplier = this._activeRouter.snapshot.paramMap.get('supplierId');
    }
    getDetailSupplier(): void {
        forkJoin([
            this.dynamicDocumentService.findByIds('dynamic_legal_entity', [this.idSupplier]),
            this.parametreNomtableService.getParametreByTable('COUNTRY'),
        ]).subscribe(([res, country]: any) => {
            const countryOriginal = country.find(
                (item: any) => item.id === res[0]?.[' country']?.[0]
            );

            this.detailSupplier = { ...res[0], countryOriginal: countryOriginal };
            if (this.detailSupplier?.logo?.length > 0) {
                this.logo = this.detailSupplier?.logo[0]?.url;
            }
            this.detailSupplier?.linkToNaturalPersons?.forEach((itemContact: any) => {
                this.listIdContact.push(itemContact?.documentId);
            });
            this.getListFile(
                this.detailSupplier?.linkToResources?.map((item: any) => item?.documentId) || []
            );
            this.getContact(this.listIdContact);
            this.getListNews();
        });
    }
    getListNews(): void {
        let arrayOfNewsValue: string[] =
            this.detailSupplier?.linkToNews?.map((item: any) => item?.value) ?? [];
        let filters = [
            {
                fieldName: 'subject',
                conditions: [
                    {
                        type: 'IN',
                        value: arrayOfNewsValue,
                    },
                ],
            },
            {
                fieldName: 'status',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'Publié',
                    },
                ],
            },
            {
                fieldName: 'lang',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'fr',
                    },
                ],
            },
        ];
        this.dynamicDocumentService
            .find(
                {
                    collectionName: 'dynamic_news',
                    filters: filters,
                    sorts: {
                        publishedOrder: 'DESC',
                    },
                    page: 1,
                    pageSize: 150,
                },
                true
            )
            .subscribe({
                next: (res) => {
                    res?.content.forEach((item: any) => {
                        item.supplierName = this.detailSupplier?.companyName;
                    });
                    this.listNews = res?.content?.filter(
                        (item: any) => item?.typeOfNews?.value === 'ACTUALITES'
                    );
                    this.listTrainingNews = res?.content?.filter(
                        (item: any) => item?.typeOfNews?.value === 'FORMATION'
                    );
                    this.listMarketingNews = res?.content?.filter(
                        (item: any) => item?.typeOfNews?.value === 'MARKETING'
                    );
                    this.listPromotionNews = res?.content?.filter(
                        (item: any) => item?.typeOfNews?.value === 'PROMOTION'
                    );
                },
                error: (error) => {},
            });
    }
    getContact(ids: any): void {
        this.dynamicDocumentService.listContact(ids).subscribe({
            next: (res) => {
                this.contactData =
                    res?.filter((item: any) => item?.status?.value === 'ACTIF') || [];
            },
            error: (error) => {},
        });
    }

    getListFile(fileIds: string[]): void {
        if (!fileIds.length) {
            return;
        }

        this.dynamicDocumentService
            .findByIds('dynamic_ressource', fileIds)
            .subscribe((dataList: any[]) => {
                const fileActive = dataList.filter((item: any) => {
                    return item?.status?.value === 'ACTIF';
                });
                let matchingItemsPhoto = fileActive.filter((item: any) => {
                    const fileName: string[] = item?.title?.split('.') ?? [];
                    const fileExtension = fileName.length ? fileName.pop() : null;

                    return (
                        item?.file?.length > 0 &&
                        (item?.typeOfResource?.value === 'FOUR' ||
                            fileExtension === 'pdf' ||
                            item?.file[0]?.url?.includes('.pdf'))
                    );
                });

                const deniedTypes: ExportResourceType[] = [];

                Object.entries(this.exportResourcePermissionMap).forEach(([ref, type]) => {
                    if (!this.permissionService.isPermissionFonction(ref)) {
                        deniedTypes.push(type);
                    }
                });

                matchingItemsPhoto = matchingItemsPhoto?.filter(
                    (r) => !deniedTypes.includes(r?.typeOfResource?.value)
                );
                matchingItemsPhoto.forEach((item: any) => {
                    this.listFileSupplier.push({
                        nameFile: item?.typeOfResource?.labels,
                        nameFileDetail: item?.title,
                        urlFile: item?.file[0]?.url,
                    });
                });
            });
    }

    pageProgress(event: any) {
        this.pdfLoaded = false;
    }

    pageRendered(event: any) {
        this.pdfLoaded = true;
    }

    openFile(item: any) {
        this.itemPdfShow = item;
        this.visibleItem = true;
    }

    public onDownload(event: any): void {
        event.preventDefault();
        event.stopPropagation();

        if (!this.itemPdfShow || !this.itemPdfShow.urlFile) {
            return;
        }

        let fileName: string = this.itemPdfShow.urlFile;
        fileName = fileName.substring(
            fileName.indexOf('/resource-files/') + '/resource-files/'.length
        );
        fileName = fileName.substring(0, fileName.indexOf('?'));

        if (this.hasUuid(fileName)) {
            fileName = fileName.substring(fileName.indexOf('_') + 1);
        }
        fileName = decodeURIComponent(fileName).toUpperCase().replace(/ /g, '-');
        fileName = fileName.replace(/["'&=$€*\/+\[\]{}|]/g, '-');

        /*  this._commonService.downloadFile(this.itemPdfShow.urlFile, fileName); */
    }

    private hasUuid(fileName: string): boolean {
        const uuid: string = fileName.substring(0, fileName.indexOf('_'));
        return (uuid.match(/-/g) || []).length === 4;
    }

    goCatalogue(supplier: Supplier | undefined) {
        if (!supplier?.code || !supplier.companyName || !supplier.id) {
            return;
        }
        if (supplier.id) {
            this.accueilDataService.filterData = {};
            this.screenMediator.toFournisseurDetail(supplier.id, supplier.title, 'detail');
        }

        this.sessionStorageService.setFilters({ suppliers: [supplier.id] });
    }

    isAnyFieldExists(field: keyof Contact): boolean {
        return this.contactData?.some((item) => !!item[field]);
    }

    getFormattedAddress(item: any): string {
        const country = item.countryOriginal?.mapLocalLibelle
            ? this.translateDynamicLanguage.transform(item.countryOriginal?.mapLocalLibelle)
            : item.country?.labels
            ? this.translateDynamicLanguage.transform(item.country?.labels)
            : '';

        const parts = [
            item.address,
            item.additionalAddress,
            item.postcode,
            item.city,
            item.region,
            country,
        ];

        return parts.filter((p) => !!p).join(', ');
    }
}
